import {Injectable} from '@angular/core';
import {AccountResourceApi} from "../../../shared/services/api/account-resource.api";

@Injectable()
export class ForgotPasswordService {
  constructor(private accountResourceApi: AccountResourceApi) {
  }

  forgotPassword(body:Object){
    return this.accountResourceApi.forgotPassword(body);
  }
}
